import { Constants } from '@leverege/molten';
import { PluginSetup as OpenApi } from '@leverege/molten-open-api';
import RemoveFromConsumerNetwork from './actions/removeFromConsumerNetwork/RemoveFromConsumerNetwork';
import FotaCountersAnalyzer from './analyzers/FotaCountersAnalyzer';
import LocationNumStaleDevices from './attributes/attributes/fota/LocationNumStaleDevices';
import LocalOpenApi from './openApi/PluginSetup';
export default {
  install(molten) {
    molten.addPlugin('Attribute', LocationNumStaleDevices);
    molten.addPlugin('Action', RemoveFromConsumerNetwork);
    molten.addPlugin(Constants.BLUEPRINTS_PROCESSOR, FotaCountersAnalyzer);
    LocalOpenApi.install(molten);
    OpenApi.install(molten);
  }
};